import React from "react";

export default function UserVerificationBadge({ status }) {
  if (status === "verified") {
    return <span className="verification-badge verified">Verificado ✓</span>;
  }

  if (status === "pending") {
    return (
      <span className="verification-badge pending">
        Pendente de análise
      </span>
    );
  }

  if (status === "rejected") {
    return <span className="verification-badge rejected">Rejeitado</span>;
  }

  return <span className="verification-badge none">Não solicitado</span>;
}
